import { defineMessages } from 'react-intl';

import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { Report_CBCT_IOS_Superimposition_Orientation } from '@/shared/api/protocol-ts/model/dto_report_type_cbct_ios_superimposition_pb';
import { OrderReportType } from '@/shared/config';

import { UploadStudyAssetType } from './types';

export const selectUploadStudyTypes = defineMessages<UploadStudyAssetType>({
  [AssetType.AssetType_Study_IntraoralXRay]: {
    id: 'uploadStudyType.intraoralXRay',
    defaultMessage: 'IOXRay',
  },
  [AssetType.AssetType_Study_CBCT]: {
    id: 'uploadAssetType.CBCT',
    defaultMessage: 'CBCT',
  },
  [AssetType.AssetType_Study_DentalPhoto]: {
    id: 'uploadAssetType.dentalPhoto',
    defaultMessage: 'Dental photo',
  },
  [AssetType.AssetType_Study_PanoramicXRay]: {
    id: 'uploadAssetType.panoramicXRay',
    defaultMessage: 'Pano',
  },
  [AssetType.AssetType_Study_IOS_Meshes]: {
    id: 'uploadAssetType.ios_stl',
    defaultMessage: 'Intraoral Scan',
  },
  [AssetType.AssetType_Document]: {
    id: 'uploadAssetType.document',
    defaultMessage: 'Document',
  },
  [AssetType.AssetType_User_Signature]: {
    id: 'uploadAssetType.document',
    defaultMessage: 'Document',
  },
  [AssetType.AssetType_OrganizationStaff_Stamp]: {
    id: 'uploadAssetType.document',
    defaultMessage: 'Document',
  },
  [AssetType.AssetType_Organization_Stamp]: {
    id: 'uploadAssetType.document',
    defaultMessage: 'Document',
  },
  [AssetType.AssetType_Organization_Logo]: {
    id: 'uploadAssetType.document',
    defaultMessage: 'Document',
  },
  [AssetType.AssetType_User_Avatar]: {
    id: 'uploadAssetType.UserAvatar',
    defaultMessage: 'User Avatar',
  },
});

export const orderReportTitle = defineMessages<OrderReportType>({
  CBCT: {
    id: 'orderReportTitle.CBCT',
    defaultMessage: 'Create CBCT AI Report',
  },
  Pano: {
    id: 'orderReportTitle.Pano',
    defaultMessage: 'Create Pano AI Report',
  },
  IOXRay: {
    id: 'orderReportTitle.IOXRay',
    defaultMessage: 'Create IOXRay AI Report',
  },
  '3DStudio': {
    id: 'orderReportTitle.3DStudio',
    defaultMessage: 'Create 3D Model',
  },
  ImplantStudio: {
    id: 'orderReportTitle.ImplantStudio',
    defaultMessage: 'Create Implant Report',
  },
  OrthoStudio: {
    id: 'orderReportTitle.OrthoStudio',
    defaultMessage: 'Create Ortho AI Report',
  },
  IOSSegmentation: {
    id: 'orderReportTitle.IOSSegmentation',
    defaultMessage: 'Create IOS AI report',
  },
  RawMeshViewer: {
    id: 'orderReportTitle.RawMeshViewer',
    defaultMessage: 'Upload Intraoral Scan',
  },
  Transcriptor: {
    id: 'orderReportTitle.Transcriptor',
    defaultMessage: 'Create Transcriptor Consultation',
  },
});

export const superimpositionOrientationInfo =
  defineMessages<Report_CBCT_IOS_Superimposition_Orientation>({
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_CBCT]:
      {
        id: 'orderReportModal.orientation.info.cbct',
        defaultMessage:
          'CBCT — Both models in CBCT coordinates. Occlusion follows the CBCT scan.',
      },
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_Zero_index]:
      {
        id: 'orderReportModal.orientation.info.zeroIndex',
        defaultMessage:
          'Zero-index — Same as CBCT, with the coordinate origin set to zero.',
      },
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_IOS]:
      {
        id: 'orderReportModal.orientation.info.ios',
        defaultMessage:
          'Intraoral Scan — Both models in Intraoral Scan coordinates. Occlusion follows the Intraoral Scan.',
      },
  });
